import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './ui/Button';
import { navigate, useRoute } from '../lib/navigation';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const currentRoute = useRoute();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#/'
  }, {
    name: 'About',
    href: '#/about'
  }, {
    name: 'Services',
    href: '#/services'
  }, {
    name: 'Newsletter',
    href: '#/newsletter'
  }];
  const isActive = (href: string) => {
    if (href === '#/' && (currentRoute === '#/' || currentRoute === '')) return true;
    return currentRoute === href;
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-2' : 'bg-white/90 backdrop-blur-sm py-4'}`} data-id="element-132">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="flex justify-between items-center" data-id="element-134">
          <a href="#/" className="flex-shrink-0" aria-label="Home" onClick={e => {
          e.preventDefault();
          navigate('#/');
        }} data-id="element-135">
            <Logo className="h-10 sm:h-12" data-id="element-136" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-137">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
            e.preventDefault();
            navigate(link.href);
          }} className={`text-sm font-medium transition-colors relative group ${isActive(link.href) ? 'text-teal' : 'text-teal/70 hover:text-teal'}`} data-id="element-138">
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-terracotta transform origin-left transition-transform duration-300 ${isActive(link.href) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-139" />
              </a>)}
            <Button size="sm" onClick={() => navigate('#/get-started')} data-id="element-140">
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-teal hover:text-sage p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-141">
            {isMobileMenuOpen ? <X size={24} data-id="element-142" /> : <Menu size={24} data-id="element-143" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-neutral-100 shadow-lg animate-fade-in-up h-screen" data-id="element-144">
          <div className="px-4 py-8 space-y-6 flex flex-col items-center" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-xl font-medium ${isActive(link.href) ? 'text-terracotta' : 'text-teal'}`} onClick={e => {
          e.preventDefault();
          navigate(link.href);
          setIsMobileMenuOpen(false);
        }} data-id="element-146">
                {link.name}
              </a>)}
            <Button className="w-full max-w-xs mt-4" onClick={() => {
          navigate('#/get-started');
          setIsMobileMenuOpen(false);
        }} data-id="element-147">
              Get Started
            </Button>
          </div>
        </div>}
    </header>;
}